import { faRocketLaunch } from "@fortawesome/pro-regular-svg-icons/faRocketLaunch";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { FC } from "react";

export const Rocket: FC<JSX.IntrinsicAttributes> = (props) => {
  return <FontAwesomeIcon icon={faRocketLaunch} {...props} />;
};
